<div class="p-24">
	<div fxLayout="row">
		<div fxFlex fxLayoutAlign="end end" fxLayoutGap="1rem">
			<a (click)="openLaneDetailsView()" class="cursor-pointer">
				<span class="primary-text"><u>Full Profile</u></span>
			</a>
		</div>
	</div>

	<div
		*ngIf="
			accountSettings.IS_FEEDBACK_ENABLED && USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN && accountId
		"
	>
		<app-carrier-feedbacks
			(feedbackClicked)="feedbackClicked.emit($event)"
			(recentFeedbackList)="recentFeedbackList.emit($event)"
			[accountId]="accountId"
			[carrierId]="capacitySearch.carrierId"
		>
		</app-carrier-feedbacks>
	</div>

	<div
		*ngIf="
			(!isContactsListInProgress && contactList.length > 0) ||
			utilService.isNullOrUndefined(contactList)
		"
		fxLayout="row"
	>
		<h3 class="primary-text" fxFlex>Representatives</h3>
	</div>

	<div
		*ngIf="
			(!isContactsListInProgress && contactList.length > 0) ||
			utilService.isNullOrUndefined(contactList)
		"
	>
		<app-carrier-contacts
			(updateContactsList)="updateContactsList($event)"
			[carrierId]="capacitySearch.carrierId"
			[carrier]="null"
			[contactList]="contactList"
			[editPrimaryContact]="editPrimaryContact"
			[isCarrierProfile]="true"
			[isEditContact]="true"
			[oldCarrierId]="null"
			[searchTruckForm]="searchTruckForm"
			[lane]="capacitySearch"
		>
		</app-carrier-contacts>
	</div>

	<div class="m-t-1">
		<div fxFlex fxLayoutAlign="end end" style="margin-right: 1rem">
			<button
				(click)="emitUserResponse.emit(userResponseSegmentPayload)"
				*ngIf="userResponseSegmentPayload != null && !feedbackExists"
				color="primary"
				mat-raised-button
			>
				Done
			</button>
		</div>
	</div>
</div>
